import Vue from "vue";
import Router from "vue-router";
import DashBoardv1 from "./views/DashBoardv1.vue";
import AddAdvertisement from "./views/AddAdvertisement.vue";
import CopyAdvertisement from "./views/CopyAdvertisement.vue";
import AddRetailer from "./views/AddRetailer.vue";
import Advertisements from "./views/Advertisements.vue";
import FrontPages from "./views/FrontPages.vue";
import AddFrontPage from "./views/AddFrontPage.vue";
import FrontPagePreview from "./views/FrontPagePreview.vue";
import Retailers from "./views/Retailers.vue";
import AddImmediateNotification from "./views/AddImmediateNotification.vue";
import AddTimedNotification from "./views/AddTimedNotification.vue";
import GiftCardStatistics from "./views/GiftCardStatistics.vue";
import ImportAccessCodes from "./views/ImportAccessCodes.vue";
import ManagePasswords from "./views/ManagePasswords.vue";
import ManageMemberIds from "./views/ManageMemberIds.vue";
import ManageMemberIdsTogetherWithCustomer from "./views/ManageMemberIdsTogetherWithCustomer.vue";
import ManageMemberPhonenumbers from "./views/ManageMemberPhonenumbers.vue";
import Notifications from "./views/Notifications.vue";
import RetailerChains from "./views/RetailerChains.vue";
import GiftCards from "./views/GiftCards.vue";
import AddGiftCard from "./views/AddGiftCard.vue";
import AdvertisementPreview from "./views/AdvertisementPreview.vue";
import ManageGameleoKeywords from "./views/GameleoKeywords.vue";
import CustomerLocations from "./views/CustomerLocations";
import BenefitCodeStats from "./views/BenefitCodeStats";
import SurrogateImportStats from "./views/SurrogateImportStats";
import Banners from "./views/Banners";
import ReportNewsLetter from "./views/ReportNewsLetter";
import AddServiceStatus from "./views/AddServiceStatus";
import Unionmembers from "./views/Unionmembers.vue";
import AddUnionmember from "./views/AddUnionmember.vue";
import NotificationsExtra from "./views/NotificationsExtra.vue";
import AddNotificationsExtra from "./views/AddNotificationsExtra.vue";
import ForgetMe from "./views/ForgetMe.vue";
import SubCategoryTypes from "./views/SubCategoryTypes.vue";
import PromoCodes from "./views/PromoCodes.vue";
import SubCategories from "./views/SubCategories.vue";
import UserPromoCodeBanners from "./views/UserPromoCodeBanners.vue";
import AddUserPromoCodeBanner from "./views/AddUserPromoCodeBanner.vue";
import UserPromocodeStats from "./views/UserPromocodeStats.vue";
import PurchaseStats from "./views/PurchaseStats.vue";
import AISearchStats from "./views/AISearchStats.vue";
import ManageMemberUsedBenefits from "./views/ManageMemberUsedBenefits.vue";
import ImportBenefitCodes from "./views/ImportBenefitCodes.vue";
import ImportSurrogates from "./views/ImportSurrogates.vue";
import AISearchPrompts from "./views/AISearchPrompts.vue";


Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Perustilastot",
      component: DashBoardv1,
    },
    {
      path: "/retailers",
      name: "Hallitse toimipaikkoja",
      component: Retailers,
    },
    {
      path: "/addretailer",
      name: "Lisää uusi toimipaikka",
      component: AddRetailer,
    },
    {
      path: "/addretailer/:id",
      name: "Muokkaa toimipaikkaa",
      component: AddRetailer,
    },
    {
      path: "/addadvertisement",
      name: "Lisää uusi kampanja",
      component: AddAdvertisement,
    },
    {
      path: "/addmobilepayadvertisement",
      name: "Lisää mobilepay kampanja",
      component: AddAdvertisement,
      props: { ismobilepayspecific: true },
    },
    {
      path: "/addmobilepayadvertisement/:id",
      name: "Muokkaa mobilepay kampanjaa",
      component: AddAdvertisement,
      props: { ismobilepayspecific: true },
    },
    {
      path: "/copyadvertisement/:id",
      name: "Kopioi uusi kampanja",
      component: CopyAdvertisement,
    },
    {
      path: "/advertisements",
      name: "Selaa kampanjoita",
      component: Advertisements,
    },
    {
      path: "/mobilepayadvertisements",
      name: "Selaa mobilepay kampanjoita",
      component: Advertisements,
      props: { ismobilepayspecific: true },
    },
    {
      path: "/addfrontpage",
      name: "Lisää uusi etusivu",
      component: AddFrontPage,
    },
    {
      path: "/addfrontpage/:id",
      name: "Muokkaa etusivua",
      component: AddFrontPage,
    },
    {
      path: "/frontpages",
      name: "Selaa etusivuja",
      component: FrontPages,
    },
    {
      path: "/addadvertisement/:id",
      name: "Muokkaa kampanjaa",
      component: AddAdvertisement,
    },
    {
      path: "/frontpagepreview/:id",
      name: "Etusivun esikatselu",
      component: FrontPagePreview,
    },
    {
      path: "/addgiftcard",
      name: "Lisää lahjakortti",
      component: AddGiftCard,
    },
    {
      path: "/aisearchprompts",
      name: "Tekoälyhaun promptit",
      component: AISearchPrompts,
    },
    {
      path: "/addgiftcard/:id",
      name: "Muokkaa lahjakorttia",
      component: AddGiftCard,
    },
    {
      path: "/managegiftcards",
      name: "Hallitse lahjakortteja",
      component: GiftCards,
    },
    {
      path: "/retailerchains",
      name: "Hallitse ketjuja",
      component: RetailerChains,
    },
    {
      path: "/promocodes",
      name: "Alennuskoodit",
      component: PromoCodes,
    },
    {
      path: "/addimmediatenotification",
      name: "Lisää heti lähetettävä ilmoitus",
      component: AddImmediateNotification,
    },
    {
      path: "/addimmediatenotification/:id",
      name: "Muokkaa heti lähetettävää ilmoitusta",
      component: AddImmediateNotification,
    },
    {
      path: "/addtimednotification",
      name: "Lisää ajoitettava ilmoitus",
      component: AddTimedNotification,
    },
    {
      path: "/addtimednotification/:id",
      name: "Muokkaa ajoitettavaa ilmoitusta",
      component: AddTimedNotification,
    },
    {
      path: "/importaccesscodes",
      name: "Lataa puhelinnumeroita kertakäyttökoodeille",
      component: ImportAccessCodes,
    },
    {
      path: "/managepasswords",
      name: "Hallitse kertakäyttökoodeja",
      component: ManagePasswords,
    },
    {
      path: "/notifications",
      name: "Selaa ilmoituksia",
      component: Notifications,
    },
    {
      path: "/forgetme",
      name: "Poistopyynnöt",
      component: ForgetMe,
    },
    {
      path: "/notificationsextra",
      name: "Selaa lisäilmoituksia",
      component: NotificationsExtra,
    },
    {
      path: "/addnotificationsextra/:id",
      name: "Lisää uusi lisäilmoitus",
      component: AddNotificationsExtra,
    },
    {
      path: "/addnotificationsextra",
      name: "Lisää uusi lisäilmoitus",
      component: AddNotificationsExtra,
    },
    {
      path: "/managenotificationunregisteredactivation",
      name: "Hallitse ilmoitusta rekisteröimättömien käyttäjien aktivoinnille",
      component: AddNotificationsExtra,
      props: { notificationType: "UNREGISTERED_ACTIVATION" },
    },
    {
      path: "/managenotificationregisteredactivation",
      name: "Hallitse ilmoitusta rekisteröityjen käyttäjien aktivoinnille",
      component: AddNotificationsExtra,
      props: { notificationType: "REGISTERED_ACTIVATION" },
    },
    {
      path: "/managenotificationpassivedregisteredactivation",
      name: "Hallitse ilmoitusta passivoituneiden rekisteröityjen käyttäjien aktivoinnille",
      component: AddNotificationsExtra,
      props: { notificationType: "PASSIVED_REGISTERED_ACTIVATION" },
    },
    {
      path: "/managememberphonenumbers",
      name: "Hallitse asiakkaan puhelinnumeroita",
      component: ManageMemberPhonenumbers,
    },
    {
      path: "/managememberids",
      name: "Hallitse jäsennumeroita",
      component: ManageMemberIds,
    },
    {
      path: "/managememberidstogetherwithcustomer",
      name: "Hallitse jäsennumeroita ja asiakkaita yhdessä",
      component: ManageMemberIdsTogetherWithCustomer,
    },
    {
      path: "/giftcardstatistics",
      name: "Lahjakorttien tilastot",
      component: GiftCardStatistics,
    },
    {
      path: "/gameleokeywords",
      name: "Gameleo-järjestelmän hakusanat",
      component: ManageGameleoKeywords,
    },
    {
      path: "/advertisementpreview/:id",
      name: "Esikatsele kamppanjaa",
      component: AdvertisementPreview,
    },
    {
      path: "/customerlocations",
      name: "Asiakkaiden sijainnit",
      component: CustomerLocations,
    },
    {
      path: "/benefitcodestats",
      name: "Etukoodien tilastot",
      component: BenefitCodeStats,
    },
    {
      path: "/surrogateimportstats",
      name: "Jäsennumeroiden ryhmätilasto",
      component: SurrogateImportStats,
    },
    {
      path: "/importbenefitcodes",
      name: "Lataa etukoodeja",
      component: ImportBenefitCodes,
    },
    {
      path: "/importsurrogates",
      name: "Lataa jäsenkoodeja",
      component: ImportSurrogates,
    },
    {
      path: "/banners",
      name: "Bannerit",
      component: Banners,
    },
    {
      path: "/reportnewsletter",
      name: "Uutiskirjeen tilanneet",
      component: ReportNewsLetter,
    },
    {
      path: "/servicestatus",
      name: "Huoltosivun hallinta",
      component: AddServiceStatus,
    },
    {
      path: "/unionmembers",
      name: "Liittojen hallinta",
      component: Unionmembers,
    },
    {
      path: "/addunionmember/:id",
      name: "Muokkaa liittoa",
      component: AddUnionmember,
    },
    {
      path: "/addunionmember",
      name: "Lisää liitto",
      component: AddUnionmember,
    },
    {
      path: "/subcategorytypes",
      name: "Alikategoriatyypit",
      component: SubCategoryTypes,
    },
    {
      path: "/subcategories",
      name: "Alikategoriat",
      component: SubCategories,
    },
    {
      path: "/userpromocodebanners",
      name: "Käyttäjien alennuskoodibannerit",
      component: UserPromoCodeBanners,
    },
    {
      path: "/adduserpromocodebanner/:id",
      name: "Muokkaa käyttäjien alennuskoodibanneria",
      component: AddUserPromoCodeBanner,
    },
    {
      path: "/adduserpromocodebanner",
      name: "Lisää käyttäjien alennuskoodibanneri",
      component: AddUserPromoCodeBanner,
    },
    {
      path: "/managememberusedbenefits",
      name: "Hallitse käytettyjä etuja",
      component: ManageMemberUsedBenefits,
    },
    {
      path: "/userpromocodestats",
      name: "Alennuskoodien tilastot",
      component: UserPromocodeStats,
    },
    {
      path: "/purchasestats",
      name: "Ostotilastot",
      component: PurchaseStats,
    },
    {
      path: "/aisearchstats",
      name: "Tekoälyetsintätilastot",
      component: AISearchStats,
    },
  ],
});
